<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-md-12">
          <h5>Export Fees</h5>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <a-form :form="form">
          <div class="row">
            <div class="col-md-2 mb-2">
              <a-form-item label="Report Type">
                <a-select
                  v-decorator="[
                    'report_type',
                    {
                      rules: [{required: true,message: 'Please select a session!!',},],
                    },
                  ]"
                  placeholder="Select report type"
                  @change="handleReportTypeChange"
                >
                  <a-select-option :value="1" :key="1"> Overall</a-select-option>
                  <a-select-option :value="2" :key="2"> Paid details</a-select-option>
                  <a-select-option :value="3" :key="3"> Daily Collection</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-2 mb-2">
              <a-form-item label="Session">
                <a-select
                  v-decorator="[
                    'session_id',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a session!!',
                        },
                      ],
                      initialValue: currentSession ? currentSession.id : '',
                    },
                  ]"
                  placeholder="Select session"
                  @change="handleSessionChange"
                >
                  <a-select-option
                    v-for="schoolSession in schoolSessions"
                    :value="schoolSession.id"
                    :key="schoolSession.id"
                  >
                    {{ schoolSession.name }}
                    <small class="text-primary ml-3">{{
                      currentSession.id === schoolSession.id ? "Current" : ""
                    }}</small>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div class="col-md-2 mb-2" v-if="showClassSection">
              <a-form-item label="Class">
                <a-spin :spinning="classSpinning">
                  <a-select
                    v-decorator="[
                      'class_id',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please select a class!!',
                          },
                        ],
                        initialValue: undefined,
                      },
                    ]"
                    placeholder="Select class"
                    @change="handleClassSelect"
                    :disabled="!selectedSessionId"
                  >
                    <a-select-option :value="0">
                      All Class
                    </a-select-option>
                    <template v-for="schoolClass in schoolClasses">
                      <a-select-option
                        :value="schoolClass.id"
                        :key="schoolClass.id"
                      >
                        {{ schoolClass.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>

            <div class="col-md-2 mb-2" v-if="showClassSection">
              <a-form-item label="Section">
                <a-spin :spinning="sectionSpinning">
                  <a-select
                    v-decorator="[
                      'section_id',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please select a section!!',
                          },
                        ],
                        initialValue: undefined,
                      },
                    ]"
                    placeholder="Select section"
                    :disabled="!form.getFieldValue('class_id') === 0"
                  >
                    <a-select-option :value="0">
                      All Section
                    </a-select-option>
                    <a-select-option
                      v-for="section in sections"
                      :value="section.id"
                      :key="section.id"
                    >
                      {{ section.name }}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>

            <div class="col-md-4 mb-2" v-if="showFee === 1" >
              <a-form-item label="Fee">
                <a-select
                  v-decorator="[
                    'fee',
                  {
                      rules: [{ required: false, message: 'Please select a fee!' }],
                      initialValue: undefined,
                  },
                  ]"
                  placeholder="Select fee"
                  :disabled="!selectedSessionId"
                  @change="handleFeeChange" >
                  <a-select-option :value="undefined">
                      Select Fee
                    </a-select-option>
                  <a-select-option v-for="type in schoolFees" :value="type.id" :key="type.id">
                  {{ type.name }}
                  </a-select-option>
                  </a-select>
                  </a-form-item>
            </div>

            <div class="col-md-2 mb-2" v-if="showDateSection">
                <a-form-item label="Start Date">
                  <a-date-picker
                    v-decorator="['start_date', {rules: [{ required: dateRequired, message: 'Please input a start date' }], initialValue: null},]"
                  />
                </a-form-item>
            </div>
            <div class="col-md-2 mb-2" v-if="showDateSection">
                <a-form-item label="End Date">
                  <a-date-picker
                    v-decorator="['end_date',{rules: [{ required: dateRequired, message: 'Please input an end date' }], initialValue: null},]"
                  />
                </a-form-item>
            </div>
          </div>
          <div class="row align-items-end">
            <div class="col-md-2 mb-2" v-if="showFee === 1" >
              <a-form-item label="Status">
                <a-select
                  v-decorator="[
                    'status',
                  {
                      rules: [{ required: false, message: 'Select Status!' }],
                      initialValue: undefined,
                  },
                  ]"
                  placeholder="All Status"
                  :disabled="!selectedSessionId"
                  @change="handleFeeChange" >

                      <a-select-option :value="undefined">All Status</a-select-option>
                      <a-select-option :value="1" :key="1">Paid</a-select-option>
                      <a-select-option :value="0" :key="0">Unpaid</a-select-option>
                  </a-select>
                  </a-form-item>
            </div>
            <div class="col-md-2 mb-2" v-if="showCreatedDateSection">
              <a-form-item label="Created on (From)">
                <a-date-picker
                  v-decorator="['created_start_date', {rules: [{ required: false, message: 'Please input a created on start date' }], initialValue: null},]"
                />
              </a-form-item>
            </div>
            <div class="col-md-2 mb-2" v-if="showCreatedDateSection">
              <a-form-item label="Created on (To)">
                <a-date-picker
                  v-decorator="['created_end_date',{rules: [{ required: false, message: 'Please input a created on end date' }], initialValue: null},]"
                />
              </a-form-item>
            </div>
            <div class="col-md-2 mb-2 ml-auto text-right">
              <a-form-item>
                <a-button
                  key="submit"
                  type="primary"
                  :loading="loading"
                  @click="handleSubmit"
                  >Export</a-button
                >
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <fee-report-charts :reportData = reportData :selectedSession=selectedSession></fee-report-charts>
  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'
import FeeReportCharts from '@/components/feemanagement/report/feereportcharts'

// const options = {
//   showLeafArrayIndexes: true,
//   includeNullValues: false,
//   mapping: function (value) {
//     if (typeof value === 'boolean') {
//       return +value ? '1' : '0'
//     }
//     return value
//   },
// }

export default {
  name: 'FeeExport',
  components: {
    FeeReportCharts,
  },
  mounted: function () {
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1])
        this.selectedSessionId = this.selectedSession.id

        this.getClasses()
        this.getSchoolFees()
        this.getReportData(this.selectedSessionId)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  computed: {
    currentSession: function () {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val
      this.selectedSessionId = val.id
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: true,
      fileList: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      fee: [],
      selectedSessionId: undefined,
      classSpinning: false,
      sectionSpinning: false,
      cl_id: null,
      value_id: null,
      status_id: null,
      sec_id: null,
      ses: null,
      start_date: null,
      end_date: null,
      created_start_date: null,
      created_end_date: null,
      showDateSection: false,
      showCreatedDateSection: false,
      showClassSection: true,
      dateRequired: false,
      showFee: null,
      reportData: null,
      selectedSession: null,
    }
  },
  methods: {
    moment,
    getClasses: function () {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: this.selectedSessionId,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },

    //   getFee() {
    //   this.$http
    //   .get('/api/class', {
    //     params: {
    //       session_id: this.selectedSessionId,
    //     },
    //   })
    //   .then(({ data }) => {
    //     this.fee = data.data
    //   })
    //   .catch((error) => {
    //     console.log(error)
    //   })
    // },
    getSchoolFees() {
      this.$http
        .get(`/api/fee`, {
          params: {
            limit: 43,
            page: 1,
          },
        })
        .then(({ data }) => {
          this.schoolFees = data.data
          // this.feesSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },

    getReportData: function (selectedSessionId) {
      this.$http
        .get('/api/fee/due/report', {
          params: {
            session_id: selectedSessionId,
          },
        })
        .then(({ data }) => {
          console.log('reportdata::', data.data)
          this.reportData = data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      // this.form.resetFields(['section_id'])
      // if (value) {
      //   this.sectionSpinning = true
      //   this.getClassSections(value)
      // }
      if (value === 0) {
        // All Classes selected, force section to "Select All Sections"
        this.form.setFieldsValue({ section_id: 0 })
        this.sectionSpinning = false
        this.sections = [] // optionally clear section options
      } else {
      // Specific class selected, reset and load sections
        this.form.setFieldsValue({ section_id: undefined })
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.$http
        .get(`/api/section/class/${value}`, {
          params: {
            session_id: this.selectedSessionId,
          },
        })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleSessionChange(value) {
      if (value) {
        this.selectedSessionId = value
      } else {
        this.selectedSessionId = this.currentSession
      }
      this.selectedSession = find(this.schoolSessions, ['id', this.selectedSessionId])
      this.form.resetFields(['class_id', 'section_id'])

      this.getClasses()
      this.getReportData(this.selectedSessionId)
    },
    // handleReportTypeChange(value) {
    //   this.showDateSection = false
    //   if (value === 2) { // If Paid details is selected
    //     this.showDateSection = true
    //   }
    // },
    handleReportTypeChange(value) {
      this.showFee = value
      // Daily Collection (3) only needs a session and a payment date range
      this.showDateSection = value === 2 || value === 3
      this.showCreatedDateSection = value === 2
      this.showClassSection = value !== 3
      this.dateRequired = value === 3
      if (value === 3) {
        this.form.resetFields(['class_id', 'section_id', 'fee', 'status'])
      }
    },

    handleSubmit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log('values:::::::::::::::')
        console.log(values.start_date)
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to Export Fees!`,
            onOk: () => {
              this.cl_id = values.class_id === 0 ? null : values.class_id
              this.value_id = values.fee
              this.status_id = values.status
              this.sec_id = values.section_id === 0 ? null : values.section_id
              this.ses_id = values.session_id
              this.start_date = values.start_date
              this.end_date = values.end_date
              this.created_start_date = values.created_start_date
              this.created_end_date = values.created_end_date
              console.log('Selected Status:', values.status) // should be 0 for unpaid

              // const params = new URLSearchParams()
              // params.append("session_id", this.ses_id)
              // params.append("class_id", this.cl_id)
              // params.append("section_id", this.sec_id)

              this.$http
                .post(
                  '/api/fee/export',
                  /* {
                    headers: {
                      'content-type': 'application/json',
                      Accept: 'application/json',
                    },
                  }, */
                  {
                    'report_type': values.report_type,
                    'session_id': this.ses_id,
                    'class_id': this.cl_id,
                    'fee_id': this.value_id,
                    'status': this.status_id,
                    'section_id': this.sec_id,
                    'start_date': this.start_date ? moment(this.start_date).format('YYYY-MM-DD') : null,
                    'end_date': this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : null,
                    'created_start_date': this.created_start_date ? moment(this.created_start_date).format('YYYY-MM-DD') : null,
                    'created_end_date': this.created_end_date ? moment(this.created_end_date).format('YYYY-MM-DD') : null,
                  },
                  {
                    responseType: 'arraybuffer',
                  }
                )
                .then((response) => {
                  /* let blob = new Blob([response.data], {
                    type: 'application/json',
                  }) */
                  this.loading = false
                  this.$notification['info']({
                    message: 'Fee export started!',
                    description: `Please check status in the Downloads page`,
                    duration: 0,
                  })

                  /* let link = document.createElement('a')
                  link.href = window.URL.createObjectURL(blob)
                  link.download = 'Export-Fee.xlsx'
                  link.click() */
                  this.form.resetFields()
                })
                .catch((error) => {
                  var enc = new TextDecoder('utf-8')
                  var bufView = new Int8Array(error)
                  this.loading = false
                  this.$neoNotify.error(JSON.parse(enc.decode(bufView)))
                })
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
